import {
  DatagridConfigurable,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  DateField,
  InfiniteList,
  UrlField,
} from "react-admin";

import { CountriesTextArrayFields } from "@/modules/countries/components/CountriesTextArrayFields";

const ListActions = () => (
  <TopToolbar
    sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
  >
    <CreateButton label="Сгенерировать новый отчет" />
    <SelectColumnsButton />
  </TopToolbar>
);

export const LeadReportsList = () => {
  return (
    <InfiniteList actions={<ListActions />} perPage={30} storeKey={false}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" label="ID" sortable={false} />
        <DateField
          source="createdAt"
          label="Дата создания"
          showTime
          sortable={false}
        />
        <DateField source="dateFrom" label="Период с" sortable={false} />
        <DateField source="dateTo" label="Период по" sortable={false} />
        <TextField source="amount" label="Сумма" sortable={false} />
        <CountriesTextArrayFields label="Страны" source="countries" />
        <TextField source="rewardType" label="Тип" sortable={false} />
        <UrlField
          source="downloadLink"
          label="Отчет (с датой и временем)"
          content="Скачать"
          sortable={false}
        />
        <UrlField
          source="downloadLink2"
          label="Отчет (только с датой)"
          content="Скачать"
          sortable={false}
        />
      </DatagridConfigurable>
    </InfiniteList>
  );
};
